/**
 * Default categorized reasons offered when an admin/moderator deletes a post.
 * This mirrors the backend seed and is used only as a fallback if the
 * community's configured list cannot be fetched.
 */
export const OTHER_DELETION_CATEGORY = "Other";

export const DEFAULT_POST_DELETION_REASONS = [
  {
    category: "Spam & Promotional Content",
    reasons: [
      "Spam / repetitive posting",
      "Unauthorized advertisement or promotion",
      "Self-promotion without approval",
      "Referral, affiliate, or MLM promotion",
      "Irrelevant external links",
    ],
  },
  {
    category: "Community Guidelines Violation",
    reasons: [
      "Off-topic / not relevant to the community",
      "Low-value or meaningless content",
      "Duplicate post",
      "Misleading or false information",
    ],
  },
  {
    category: "Academic Integrity & Misconduct",
    reasons: [
      "Academic misconduct / cheating-related content",
      "Assignment answer sharing",
      "Examination answer sharing",
      "Promotion of unfair academic practices",
    ],
  },
  {
    category: "Harassment & Conduct",
    reasons: [
      "Harassment or bullying",
      "Hate speech or discriminatory content",
      "Offensive or abusive language",
      "Personal attack on another member",
      "Threatening or intimidating behavior",
    ],
  },
  {
    category: "Privacy & Security",
    reasons: [
      "Sharing personal information",
      "Privacy violation",
      "Sharing confidential University information",
    ],
  },
  {
    category: "Copyright & Intellectual Property",
    reasons: [
      "Copyright infringement",
      "Unauthorized sharing of paid content",
      "Inappropriate image or media",
      "Adult or explicit content",
      "Violent or disturbing content",
    ],
  },
  {
    category: OTHER_DELETION_CATEGORY,
    reasons: [],
  },
];

/**
 * Validate a categorized reason selection.
 * @returns {{ valid: boolean, message?: string }}
 */
export function validateDeletionReason({ category, detail, note } = {}) {
  if (!category) {
    return { valid: false, message: "Please choose a reason category" };
  }
  if (category === OTHER_DELETION_CATEGORY) {
    if (!note || !note.trim()) {
      return {
        valid: false,
        message: "Please provide the reason for removing this post",
      };
    }
    return { valid: true };
  }
  if (!detail) {
    return { valid: false, message: "Please choose a specific reason" };
  }
  return { valid: true };
}

/**
 * Build the request body sent to the delete endpoint from a reason selection.
 */
export function buildDeletionReasonBody({ category, detail, note } = {}) {
  return {
    reasonCategory: category,
    reasonDetail: category === OTHER_DELETION_CATEGORY ? "" : detail,
    reason: note ? note.trim() : "",
  };
}
